export const environment = {
  development: true,
  homolog: false,
  production: false,
  demo: window.location.href.startsWith('https://izii-hub-demo.web.app'),
  // demo: true,
  appVersion: require('../../package.json').version,

  //apiUrl: 'https://dev-hub-rh.azurewebsites.net/api',
  apiUrl: 'https://api.dev.hubdorh.com.br/api',

  // Assistente Izii (chat com IA): so dev e local. Com false o menu
  // nao mostra o item e a rota nem casa. O backend tem a propria chave.
  chatIaDisponivel: true,
};
